/* eslint-disable max-len */
import 'react';

const CopyToBtnDisabledSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_2128_51093" style={{'maskType': 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
            <rect width="20" height="20" fill="black" />
        </mask>
        <g mask="url(#mask0_2128_51093)">
            <path d="M14.9998 2.70801C16.2653 2.70801 17.2916 3.73354 17.2918 4.99902V12.083C17.2917 13.3485 16.2654 14.374 14.9998 14.374H13.9588V15.416C13.9588 16.6817 12.9325 17.708 11.6668 17.708H4.5838C3.31815 17.708 2.29181 16.6817 2.29181 15.416V8.33301C2.29181 7.06736 3.31815 6.04102 4.5838 6.04102H5.62482V4.99902C5.62501 3.73354 6.65128 2.70801 7.91681 2.70801H14.9998ZM4.5838 7.29102C4.00851 7.29102 3.54181 7.75771 3.54181 8.33301V15.416C3.54181 15.9913 4.0085 16.458 4.5838 16.458H11.6668C12.2421 16.458 12.7088 15.9913 12.7088 15.416V8.33301C12.7088 7.75771 12.2421 7.29102 11.6668 7.29102H4.5838ZM7.91681 3.95801C7.34163 3.95801 6.87501 4.42389 6.87482 4.99902V6.04102H11.6668C12.9325 6.04102 13.9588 7.06736 13.9588 8.33301V13.124H14.9998C15.575 13.124 16.0417 12.6582 16.0418 12.083V4.99902C16.0416 4.42389 15.575 3.95801 14.9998 3.95801H7.91681Z" fill="#BEC2CC" />
        </g>
    </svg>

);
export default CopyToBtnDisabledSvg;
